import { Request } from '@/lib/http';
import AuthEnum from '../lib/enums/auth-enum';

const baseURL = '/api/intelligence';

export default {
  getIntelligenceReports(tenantId) {
    const request = new Request(`${baseURL}/${tenantId}/intelligence-reports`, {
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
};
